import { render } from "./VVideo.vue?vue&type=template&id=20b82f33"
import script from "./VVideo.vue?vue&type=script&lang=js"
export * from "./VVideo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__